// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2f5r8","author":"Table_author__3aa24","authorImage":"Table_authorImage__bva0m","unreadRow":"Table_unreadRow__25G_l"};